import AjaxForm from './class/AjaxForm';

window.mokaForm = function(f) {
	return new AjaxForm( document.querySelector(f) );
};
